import { apiClient } from "./apiClient";

export async function sendEmail(payload: { to: string; subject?: string; body?: string }) {
  const { data } = await apiClient.post("/email/send", payload);
  return data;
}
